import { render, staticRenderFns } from "./homeVideo.vue?vue&type=template&id=6f47fc7c&scoped=true&"
import script from "./homeVideo.vue?vue&type=script&lang=js&"
export * from "./homeVideo.vue?vue&type=script&lang=js&"
import style0 from "./homeVideo.vue?vue&type=style&index=0&id=6f47fc7c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f47fc7c",
  null
  
)

export default component.exports